import { render, staticRenderFns } from "./Konstruktor.vue?vue&type=template&id=6d72ab8a&"
import script from "./Konstruktor.vue?vue&type=script&lang=js&"
export * from "./Konstruktor.vue?vue&type=script&lang=js&"
import style0 from "./Konstruktor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports